/**
 * Make sure input/textarea blur events are triggered on iOS devices.
 *
 * @see     https://github.com/wikieswan/iphone-input-blur
 * @author  https://github.com/wikieswan
 */
(($) => {
  if (typeof $ === 'undefined') {
    App.sendErrorToRaygun(
      'Iphone-input-blur: you should include jquery.js or zepto.js before',
    );
    return false;
  }

  let cacheInput = null;
  let timer = null;
  // eslint-disable-next-line no-use-before-define
  if (!isApple()) {
    return false;
  }
  $(document).on('focus', 'input', (e) => {
    cacheInput = e.target;
  });
  $(document).on('focus', 'textarea', (e) => {
    cacheInput = e.target;
  });
  $(document).on('touchend', (e) => {
    if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
      if (cacheInput !== null) {
        // Hide keyboard after 300 ms
        timer = setTimeout(() => {
          cacheInput.blur();
          clearTimeout(timer);
        }, 300);
      }
    }
  });

  function isApple() {
    const ua = navigator.userAgent.toUpperCase();
    const ipad = ua.indexOf('IPAD') > -1;
    const ipod = ua.indexOf('IPOD') > -1;
    const iphone = ua.indexOf('IPHONE') > -1;
    return ipad || ipod || iphone;
  }

  return true;
})($);
